"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconBellOutline = props => /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
  viewBox: "0 0 24 24",
  ...props,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M10.01 20.76C10.01 21.86 10.9 22.75 12 22.75 13.1 22.75 13.99 21.86 13.99 20.76L10.01 20.76ZM12 5.75C14.76 5.75 17 7.99 17 10.75L17 17.75 7 17.75 7 10.75C7 7.99 9.24 5.75 12 5.75ZM12 1.25C11.17 1.25 10.5 1.92 10.5 2.75L10.5 3.92C7.36 4.6 5 7.4 5 10.75L5 16.75 3 18.75 3 19.75 21 19.75 21 18.75 19 16.75 19 10.75C19 7.4 16.64 4.6 13.5 3.92L13.5 2.75C13.5 1.92 12.83 1.25 12 1.25Z"
  })
});
var _default = exports.default = (0, _withIcon.default)('IconBellOutline')(IconBellOutline);